import $ from 'jquery';

const selectors = {
	toggler: '.js-subnav__children-toggler',
	children: '.js-subnav__children',
};

var module = {
	init() {
		module._initEvents();
	},

	_initEvents() {
		const togglerElements = document.querySelectorAll('.js-subnav__children-toggler');


		// Add a click event listener to each toggler
		togglerElements.forEach(toggler => {
			toggler.addEventListener('click', (e) => {
				// Prevent default action if the target is a link or a button inside the list
				if (e.target.closest('.js-subnav__children')) {
					return; // Allow link behavior (navigate)
				}

				const subnavChildren = toggler.nextElementSibling;

				// Check if the sibling exists and has the correct class
				if (subnavChildren && subnavChildren.classList.contains('js-subnav__children')) {
					subnavChildren.classList.toggle('is-hidden');
				}
			});
		});
	}
}

export { module as Subnav };